import {Button, Typography} from "@mui/material";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ButtonSelectAction = ({onClick, text, width = 240, height = 56, disabled = false, showIcon = true}) => {
    return <Button
        onClick={onClick}
        variant="outlined"
        disabled={disabled}
        sx={{
            width: width,
            height: height,
            borderRadius: "100px",
            color: (theme) => theme.palette.text.main,
            border: (theme) => `${theme.palette.secondary.add} 1px solid`,
            padding: "0 24px",
            display: 'flex',
            justifyContent: showIcon ? "space-between" : "center",
            textTransform: 'none',
            "&:hover": {
                border: (theme) => `${theme.palette.secondary.add} 1px solid`,
                backgroundColor: "inherit",
            }
        }}
    >
        <Typography>{text}</Typography>
        {showIcon && <KeyboardArrowUpIcon/>}
    </Button>
}
export default ButtonSelectAction